import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const evoeldConfig: TSPConfig = {
  key: 'evoeld',
  name: 'EvoELD',
  imageName: 'EvoELD',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect your EvoELD account, you'll need the following credentials:
      </p>
      <ol>
        <li>x-access-token (Authorization Code)</li>
        <li>provider-token (API Key)</li>
        <li>US DOT Number</li>
      </ol>
      <p>
        Please contact your EvoELD administrator if you need help finding these
        credentials.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'x-access-token',
          name: 'apikey',
          type: 'text',
          required: true,
        },
        {
          label: 'provider-token',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
        {
          label: 'US DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default evoeldConfig;
